export const formOrderNaming = {
  NEW_WORK_ORDER_FORM: 'new-work-order-form',
  NEW_DUPLICATE_WORK_ORDER_FORM: 'new-duplicate-work-order-form',
  NEW_CAMPAIGN_FORM: 'new-campaign-form',
  EDIT_CAMPAIGN_FORM: 'edit-campaign-form',
  NEW_SURVEILLANCE_ROUTE_ORDER_FORM: 'new-surveillance-route-order-form',
};
